// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleRelatedVideos_root__30mKd","header":"ArticleRelatedVideos_header__3zkLJ","wrapper":"ArticleRelatedVideos_wrapper__3tAmc","video":"ArticleRelatedVideos_video__2OYqE"};